/*
  Search page: extra sort orders (Alphabetically A-Z / Z-A, Date new-old /
  old-new) on top of Shopify's own relevance and price sorts.

  Shopify only sorts search results by relevance or price, so for these orders
  the page collects every result of the current search + filters from the
  bulk view (templates/search.all.json, 48 per page), sorts them here and pages
  through them itself. The options are only offered up to 500 results
  (snippets/collection-page-body.liquid), and re-sorting follows every AJAX
  filter change through collection-ajax.js's `collection:results-updated`.

  Every card carries data-sort-title and data-sort-created for this.
*/
(function () {
  'use strict';

  var ORDERS = {
    'title-ascending': { key: 'title', dir: 1 },
    'title-descending': { key: 'title', dir: -1 },
    'created-descending': { key: 'created', dir: -1 },
    'created-ascending': { key: 'created', dir: 1 }
  };
  var MAX_RESULTS = 500;
  var BULK_PAGE_SIZE = 48;

  var cache = {};
  var run = 0;
  var state = null;

  function currentOrder() {
    return ORDERS[new URLSearchParams(window.location.search).get('sort_by') || ''] || null;
  }

  function grid() {
    return document.querySelector('[data-search-sort-grid]');
  }

  // The current search and filters, without paging, sorting or template view.
  function baseParams() {
    var params = new URLSearchParams(window.location.search);
    ['page', 'sort_by', 'view', 'section_id'].forEach(function (key) { params.delete(key); });
    return params;
  }

  function fetchBulkPage(params, page) {
    var query = new URLSearchParams(params);
    query.set('view', 'all');
    if (page > 1) query.set('page', String(page));
    return fetch(window.location.pathname + '?' + query.toString(), { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Search page ' + page + ' failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('[data-search-sort-grid] .product-grid__item'));
      });
  }

  function loadAllResults(total) {
    var params = baseParams();
    var key = params.toString();
    if (cache[key]) return Promise.resolve(cache[key]);
    var pages = Math.ceil(total / BULK_PAGE_SIZE);
    var requests = [];
    for (var page = 1; page <= pages; page++) requests.push(fetchBulkPage(params, page));
    return Promise.all(requests).then(function (lists) {
      var items = [].concat.apply([], lists).map(function (node, index) {
        return {
          node: node,
          index: index,
          title: node.getAttribute('data-sort-title') || '',
          created: Number(node.getAttribute('data-sort-created')) || 0
        };
      });
      cache[key] = items;
      return items;
    });
  }

  function sortItems(items, order) {
    return items.slice().sort(function (a, b) {
      var result = order.key === 'title'
        ? a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true })
        : a.created - b.created;
      // Equal keys keep Shopify's relevance order.
      return result * order.dir || a.index - b.index;
    });
  }

  function paginationMarkup(target, page, pages) {
    var wrap = document.createElement('nav');
    wrap.className = 'pagination';
    wrap.setAttribute('aria-label', target.dataset.labelPagination || 'Pagination');
    var inner = document.createElement('div');
    inner.className = 'pagination__wrapper';

    var arrow = function (direction, label, toPage) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'pagination__link pagination__link--' + direction + (toPage ? '' : ' pagination__link--disabled');
      button.textContent = label;
      if (toPage) button.dataset.searchSortPage = String(toPage);
      else button.disabled = true;
      return button;
    };

    inner.appendChild(arrow('prev', target.dataset.labelPrevious || 'Previous', page > 1 ? page - 1 : 0));
    var numbers = document.createElement('div');
    numbers.className = 'pagination__numbers';
    for (var i = 1; i <= pages; i++) {
      // Keep the list short: first, last and two either side of the current page.
      if (i !== 1 && i !== pages && Math.abs(i - page) > 2) {
        if (!numbers.lastChild || !numbers.lastChild.classList.contains('pagination__ellipsis')) {
          var gap = document.createElement('span');
          gap.className = 'pagination__ellipsis';
          gap.textContent = '…';
          numbers.appendChild(gap);
        }
        continue;
      }
      var number = document.createElement(i === page ? 'span' : 'button');
      number.className = 'pagination__number' + (i === page ? ' pagination__number--current' : '');
      number.textContent = String(i);
      if (i === page) number.setAttribute('aria-current', 'page');
      else { number.type = 'button'; number.dataset.searchSortPage = String(i); }
      numbers.appendChild(number);
    }
    inner.appendChild(numbers);
    inner.appendChild(arrow('next', target.dataset.labelNext || 'Next', page < pages ? page + 1 : 0));
    wrap.appendChild(inner);
    return wrap;
  }

  function showPage(page, scroll) {
    var target = grid();
    if (!target || !state) return;
    var size = Number(target.dataset.pageSize) || 24;
    var pages = Math.max(1, Math.ceil(state.items.length / size));
    page = Math.min(Math.max(1, page), pages);
    state.page = page;

    var slice = state.items.slice((page - 1) * size, page * size);
    target.replaceChildren.apply(target, slice.map(function (item) { return document.importNode(item.node, true); }));

    var pagination = document.querySelector('[data-collection-pagination]');
    if (pages > 1) {
      if (!pagination) {
        pagination = document.createElement('div');
        pagination.className = 'collection-pagination';
        pagination.setAttribute('data-collection-pagination', '');
        target.insertAdjacentElement('afterend', pagination);
      }
      pagination.hidden = false;
      pagination.replaceChildren(paginationMarkup(target, page, pages));
    } else if (pagination) {
      pagination.hidden = true;
    }

    var count = document.querySelector('[data-results-count]');
    if (count && target.dataset.rangeTemplate) {
      count.textContent = target.dataset.rangeTemplate
        .replace('[from]', String((page - 1) * size + 1))
        .replace('[to]', String(Math.min(page * size, state.items.length)))
        .replace('[count]', String(state.items.length));
    }

    if (scroll) {
      var results = document.querySelector('[data-collection-results]') || target;
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function apply() {
    var order = currentOrder();
    var target = grid();
    state = null;
    if (!order || !target) return;
    var total = Number(target.dataset.total) || 0;
    if (total < 2 || total > MAX_RESULTS) return;

    var thisRun = ++run;
    var root = document.querySelector('[data-ajax-filters]');
    if (root) root.classList.add('is-loading-results');
    target.setAttribute('aria-busy', 'true');

    loadAllResults(total)
      .then(function (items) {
        if (thisRun !== run) return;
        state = { items: sortItems(items, order), page: 1 };
        showPage(1, false);
      })
      .catch(function () {
        // Leave Shopify's own order in place if any page fails to load.
      })
      .finally(function () {
        if (thisRun !== run) return;
        if (root) root.classList.remove('is-loading-results');
        target.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-search-sort-page]');
    if (!button || !state) return;
    event.preventDefault();
    showPage(Number(button.dataset.searchSortPage), true);
  });

  document.addEventListener('collection:results-updated', apply);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
